import {
    Component,
    createNgModuleRef,
    Injector, NgZone,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {ResourceModel} from "../../core/models/resources/resource.model";

@Component({
    selector: 'events-viewer-dynamic-load',
    template: '<div class="events-viewer-dynamic-load"><ng-container #container></ng-container></div>',
    styleUrls: ['./events-viewer-dynamic-load.component.scss'],
    standalone: false
})
export class EventsViewerLoadDynamic implements OnInit {
    @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;


    constructor(
        private injector: Injector,
        private _ngZone: NgZone,
    ) { }

    ngOnInit(): void {
        this.loadEventsViewerComponent().then(() => {}, console.error);
    }

    async loadEventsViewerComponent() {
        // Dynamically load the component based on the last segment
        const { EventsModule } = await import('./events.module');
        const moduleRef = createNgModuleRef(EventsModule, this.injector);
        return this.container.createComponent(EventsModule.components.eventsViewerComponent, { ngModuleRef: moduleRef });
    }

    async loadResourceEventsViewerComponent(resource: ResourceModel) {
        const { EventsModule } = await import('./events.module');
        const moduleRef = createNgModuleRef(EventsModule, this.injector);
        const eventsComponentRef = this.container.createComponent(EventsModule.components.eventsViewerComponent, { ngModuleRef: moduleRef });
        const eventsComponentInstance = eventsComponentRef.instance;
        eventsComponentInstance.resourceModel = resource;
        eventsComponentInstance.enableFullScreen = true;
        this._ngZone.run(() => { eventsComponentInstance.loadData(); });
        return eventsComponentInstance;
    }

}